import { useContext } from 'react'
import { Context } from '../state'

export const useGlobalState = () => {
   const context = useContext(Context)
   return context
}